import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_PertinentCategory } from '@app/advisor-ui-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onPertinentCategoryUpdated = new ThunderDispatcherV3('__onPertinentCategoryUpdated');
export class ModuleFE_PertinentCategory_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_PertinentCategory, dispatch_onPertinentCategoryUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_PertinentCategory = new ModuleFE_PertinentCategory_Class();
//# sourceMappingURL=ModuleFE_PertinentCategory.js.map